import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import DatePicker from 'react-datepicker';
import Slider from '@material-ui/core/Slider';
import { makeStyles } from '@material-ui/core/styles';

export default function AuctionDetailsForm({auctionInfo, setAuctionInfo}) {

    return (
        <>
            <Typography variant="h6" gutterBottom>
                Auction details
            </Typography>
            <Grid container spacing={3}>

                {/******************  AUCTION TITLE  ****************************/}
                <Grid item xs={12}>
                <TextField
                    required
                    value={auctionInfo.title}
                    id="title_id"
                    name="title"
                    label="Auction title"
                    fullWidth
                    onChange={e => setAuctionInfo({...auctionInfo, title: e.target.value})}
                />
                </Grid>

                {/******************  AUCTION CATEGORY  ****************************/}
                <Grid item xs={12}>
                    <Select
                        required
                        value={auctionInfo.category}
                        id="category_id"
                        name="category"
                        label="Category"
                        fullWidth
                        onChange={e => setAuctionInfo({...auctionInfo, category: e.target.value})}
                        fullWidth
                    >
                        <MenuItem value="Cars">Cars</MenuItem>
                        <MenuItem value="Mortobikes and bicycles">Mortobikes and bicycles</MenuItem>
                        <MenuItem value="Furniture">Furniture</MenuItem>
                        <MenuItem value="Clothings">Clothings</MenuItem>
                    </Select>
                </Grid>

                {/******************  AUCTION DESCRIPTION  ****************************/}
                <Grid item xs={12}>
                <TextField
                    required
                    value={auctionInfo.description}
                    id="description_id"
                    name="description"
                    label="Auction description"
                    fullWidth
                    onChange={e => setAuctionInfo({...auctionInfo, description: e.target.value})}
                />
                </Grid>

                {/******************  START DATE  ****************************/}
                <Grid item xs={12} sm={6}>
                <TextField
                    fullWidth
                    id="start_date_id"
                    name="start_date"
                    label="Auction start"
                    type="datetime-local"
                    format="MM/dd/yyyy"
                    onChange={e => setAuctionInfo({...auctionInfo, start_date: e.target.value})}
                    InputLabelProps={{
                    shrink: true,
                    }}
                />
                </Grid>

                {/******************  END DATE  ****************************/}
                <Grid item xs={12} sm={6}>
                <TextField
                    fullWidth
                    id="end_date_id"
                    name="ends_date"
                    label="Auction end"
                    type="datetime-local"
                    format="MM/dd/yyyy"
                    onChange={e => setAuctionInfo({...auctionInfo, ends_date: e.target.value})}
                    InputLabelProps={{
                    shrink: true,
                    }}
                />
                </Grid>

                {/******************  BUDGET ****************************/}
                <Grid item container xs={12} sm={6} justify='space-between'>
                    <Typography variant='body1'>Budget</Typography>
                    <Slider 
                            style={{paddingTop: '40px', color: '#15616d'}}
                            value={auctionInfo.budget || 0}
                            min={0}
                            max={20000}
                            onChange={(event, newBudget) => setAuctionInfo(prevInfo => ({...prevInfo, budget: newBudget}))}
                            valueLabelDisplay="auto"
                            aria-labelledby="budget"
                    />
                    <Typography variant='caption'>min: {(auctionInfo.budget && auctionInfo.budget[0]) || 0} € </Typography>
                    <Typography variant='caption'>max: {(auctionInfo.budget && auctionInfo.budget[1]) || 20000} € </Typography>
                </Grid>
                
                {/******************  VOLUME ****************************/}
                <Grid item container xs={12} sm={6} justify='space-between'>
                    <Typography variant='body1'>Volume</Typography>
                    <Slider
                    style={{paddingTop: '40px', color: '#15616d'}}
                    value={auctionInfo.volume || 0}
                    min={0}
                    max={10000}
                    onChange={(event, newVolume) => setAuctionInfo(prevInfo => ({...prevInfo, volume: newVolume}))}
                    valueLabelDisplay="auto"
                    aria-labelledby="volume"
                    />
                    <Typography variant='caption'>min: {(auctionInfo.volume && auctionInfo.volume[0]) || 0} cbm </Typography>
                    <Typography variant='caption'>max: {(auctionInfo.volume && auctionInfo.volume[1]) || 10000} cbm </Typography>
                </Grid>
                
            </Grid>
        </>
    );
}
